export default __webpack_public_path__ + "static/media/10-Nature_preview.9106f71d.jpg";